import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaCheckCircle, FaArrowRight } from 'react-icons/fa';
import Layout from '../components/layout/Layout';
import logo from '../assets/logo.png';
import { showToast } from '../components/ui/Toast';
import './ForgotPassword.css'; // Reusing the same CSS

const PasswordResetSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { email } = location.state || {};

  useEffect(() => {
    if (!email) {
      navigate('/forgot-password');
    }
  }, [email, navigate]);

  useEffect(() => {
    showToast.success('Password reset successful!');
  }, []);

  return (
    <Layout>
      <div className="forgot-password-page-container">
        <div className="forgot-password-split-screen">
          <div className="forgot-password-left-panel">
            <div className="forgot-password-content">
              <img src={logo} alt="UniTrade Logo" className="forgot-password-logo" />
              <h2>Password Reset Successful</h2>
              <p>You can now log in with your new password.</p>
            </div>
          </div>
          <div className="forgot-password-right-panel">
            <div className="forgot-password-form-container success-container">
              <div className="success-icon-container">
                <FaCheckCircle className="success-icon" />
              </div>
              <h3>All Done!</h3>
              <p className="success-message">
                Your password has been successfully reset. You can now log in with your new password.
              </p>
              <button 
                className="forgot-btn"
                onClick={() => navigate('/login')}
              >
                Back to Login <FaArrowRight className="ms-1" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PasswordResetSuccess;
